import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import BookingPage from './pages/BookingPage';
import ProviderDashboard from './pages/ProviderDashboard';
import AdminAccessPage from './pages/AdminAccessPage';
import Navbar from './components/Navbar';
import UserBookings from './pages/UserBooking';



function App() {
  return (
    <Router>
      <div className="bg-white min-h-screen">
        <Navbar className="flex justify-between items-center p-4 shadow">
          <h1 className="text-xl font-bold">Parking Sharing Service</h1>
          <div className="space-x-4">
            <Link to="/login" className="text-blue-500">Login</Link>
            <Link to="/register" className="text-blue-500">Register</Link>
          </div>
        </Navbar>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/book/:spaceId" element={<BookingPage />} />
          <Route path="/dashboard" element={<ProviderDashboard />} />
          <Route path="/admin/access" element={<AdminAccessPage />} />
          <Route path="/my-bookings" element={<UserBookings />} /> 

        </Routes>
      </div>
    </Router>
  );
}

export default App;
